import {
  DsaLeaderboardApiResponse,
  HackathonApiResponse,
  HackathonData,
  NewLeaderBoardApiResponse
} from 'features/Leaderboard'
import { useInfiniteQuery, useQuery } from 'react-query'

import { API_ENDPOINTS } from 'config/api'
import axios from 'config/axios'

export const fetchDsaLeaderboard = async (currentPage: number) => {
  const response = await axios.get(
    `${API_ENDPOINTS.LEADERBOARD}?page=${currentPage}&size=20`
  )
  return response.data.data.attributes
}

export const useDsaLeaderBoard = () => {
  return useInfiniteQuery<DsaLeaderboardApiResponse, null>(
    ['DSA-Leaderboard'],
    ({ pageParam = 1 }) => fetchDsaLeaderboard(pageParam),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.id < lastPage.count) {
          return lastPage.id + 1
        }
        return undefined
      }
    }
  )
}

export const fetchAllHackathon = async () => {
  const response = await axios.get(API_ENDPOINTS.HACKATHON)

  const data = response.data as HackathonApiResponse

  return data.data
    .map((val) => ({ id: val.id, ...val.attributes }))
    .sort((first, second) => {
      return (
        new Date(second.ending_date).getTime() -
        new Date(first.ending_date).getTime()
      )
    })
}

export const useHackathonLeaderboardQuery = () => {
  return useQuery<HackathonData[], null>('hackathon', fetchAllHackathon)
}

/**
 * use to fetch new Leaderboard for DSA and Frontend
 * @param currentPage current page no
 * @param courseType  course type (dsa or frontend)
 * @param courseTimeline weekly or monthly
 * @param pageSize current page size
 */

export const fetchNewLeaderboard = async (
  currentPage: number,
  courseType: string,
  courseTimeline: string,
  pageSize: number
) => {
  const response = await axios.get(
    `${API_ENDPOINTS.LEADERBOARD}?course_type=${courseType}&course_timeline=${courseTimeline}&page=${currentPage}&size=${pageSize}`
  )
  const data = response.data.data.attributes as NewLeaderBoardApiResponse

  return data
}

export const useNewLeaderBoard = (
  currentPage: number,
  courseType: string,
  courseTimeline: string,
  pageSize: number
) => {
  return useQuery<NewLeaderBoardApiResponse, null>(
    ['NEW-Leaderboard', currentPage, courseType, courseTimeline, pageSize],
    () =>
      fetchNewLeaderboard(currentPage, courseType, courseTimeline, pageSize),
    {
      enabled: !!(currentPage && courseType && courseTimeline),
      refetchOnWindowFocus: 'always'
    }
  )
}
